<template><div><h1>VUX V2.7.2 released</h1>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[feature] now we can use Alert as a module (import { AlertModule } from 'vux') #2173</li>
</ul>
<h2><a href="/en/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] add prop:readonly #2178</li>
<li>[fix] fix event:on-change fires multiple times</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] set default start-date if end-date is specified but start-date is not #2158</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] fix reset-value issue in multiple mode #2160</li>
<li>[fix] fix props missing in calendar #2105</li>
<li>[fix] fix disabled weekends still selectable #2178</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[feature] add prop:value-map for automatically transform API data #2139</li>
<li>[feature] add method:getFullValue for getting full value</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[feature] support prop:prevent-default #2176</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.2-130.vue?a91b33b8